const dismissPropertyChecklist = () => ({
  type: 'PREFERENCES_PROPERTY_CHECKLIST_DISMISS'
})
const dismissPropertyDescriptionForReview = (userId) => ({
  type: 'PREFERENCES_DESCRIPTION_FOR_REVIEW_DISMISS',
  userId,
})

const dismissInfoBar = (infoId, userId) => ({
  type: 'PREFERENCES_INFOBAR_DISMISS',
  infoId,
  userId,
})

const dismissRoomImageManagementWhatsNew = (userId, permanent = false) => ({
  type: 'PREFERENCES_ROOM_IMAGE_MANAGEMENT_WHATS_NEW_DISMISS',
  userId,
  permanent,
})

export const preferencesActions = {
  dismissPropertyChecklist,
  dismissPropertyDescriptionForReview,
  dismissInfoBar,
  dismissRoomImageManagementWhatsNew,
}
